import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'

const { DialpadShowButton: showButtonColors } = phoneColorKeys.Phone

export enum DialpadShowButtonVariants {
  CLOSED = 'closed',
  OPEN = 'open',
}

const DialpadShowButtonParts = [
  'container',
  'showButton',
  'showButtonIcon',
  'showButtonText',
  'slidingPanel',
] as const

const helpers = createMultiStyleConfigHelpers(DialpadShowButtonParts)
export const DialpadShowButton = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      width: 'full',
      justifyContent: 'center',
    },
    showButton: {
      justifyContent: 'center',
      alignItems: 'center',
      width: 'full',
      paddingX: '1.25rem',
      paddingY: '0.44rem',
      gap: '0.75rem',
      backgroundColor: showButtonColors.ShowButton.Background,
      border: '1px solid',
      borderColor: showButtonColors.ShowButton.BorderColor,
      cursor: 'pointer',
    },
    showButtonIcon: {
      boxSize: '1.37rem',
    },
    showButtonText: {
      userSelect: 'none',
      textStyle: textStyleKeys.Body2,
    },
    slidingPanel: {
      position: 'absolute',
      height: 'fit-content',
      paddingTop: '1.75rem',
      paddingBottom: '1.25rem',
      paddingX: '1.25rem',
      border: '1px solid',
      borderColor: showButtonColors.SlidingPanel.BorderColor,
      backgroundColor: showButtonColors.SlidingPanel.Background,
      transition: 'all 0.25s ease-in-out',
    },
  },
  variants: {
    [DialpadShowButtonVariants.CLOSED]: {
      slidingPanel: {
        bottom: '-25rem',
      },
    },
    [DialpadShowButtonVariants.OPEN]: {
      slidingPanel: {
        bottom: '2.25rem',
      },
    },
  },
})

export const useDialpadShowButtonStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof DialpadShowButtonParts>(
    getName({ DialpadShowButton }),
    props,
  )
}
